import { CountryIconProps } from './types';

const VE = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3777)">
      <path
        d="M22.8093 17.2166C23.5722 15.639 24 13.8692 24 11.9993C24 10.1294 23.5722 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189C0.427828 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427828 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166Z"
        fill="#0052B4"
      />
      <path
        d="M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19043C3.13143 21.2317 7.24218 24.0004 11.9997 24.0004Z"
        fill="#D80027"
      />
      <path
        d="M20.7824 14.3561L20.1486 14.8514L20.4236 15.607L19.7568 15.1574L19.1229 15.6525L19.3445 14.8793L18.6777 14.4295L19.4816 14.4015L19.7034 13.6283L19.9786 14.3841L20.7824 14.3561Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.1585 11.5444L18.7324 12.2266L19.2495 12.8426L18.469 12.6483L18.0427 13.3303L17.9865 12.5279L17.2061 12.3333L17.9519 12.0319L17.8959 11.2295L18.4129 11.8458L19.1585 11.5444Z"
        fill="#F0F0F0"
      />
      <path
        d="M16.6724 9.45837L16.5052 10.2452L17.2018 10.6474L16.4019 10.7317L16.2346 11.5183L15.9074 10.7835L15.1074 10.8675L15.7053 10.3293L15.3781 9.59455L16.0747 9.99664L16.6724 9.45837Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.6219 8.34802L13.7339 9.14457L14.526 9.28416L13.8031 9.63695L13.9151 10.4334L13.3563 9.85482L12.6332 10.2074L13.0109 9.49712L12.4521 8.91859L13.2443 9.05823L13.6219 8.34802Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.3767 8.34802L10.7544 9.05822L11.5464 8.91849L10.9878 9.49726L11.3653 10.2075L10.6424 9.85482L10.0835 10.4333L10.1956 9.63694L9.47266 9.28435L10.2648 9.14457L10.3767 8.34802Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.32614 9.45837L7.92399 9.99664L8.62041 9.59455L8.29336 10.3295L8.89106 10.8677L8.09114 10.7835L7.76386 11.5183L7.59684 10.7315L6.79688 10.6475L7.49344 10.2453L7.32614 9.45837Z"
        fill="#F0F0F0"
      />
      <path
        d="M4.83973 11.5444L5.58565 11.8457L6.10249 11.2296L6.04657 12.0322L6.79225 12.3335L6.01183 12.528L5.95563 13.3303L5.52954 12.6483L4.74902 12.8428L5.26605 12.2266L4.83973 11.5444Z"
        fill="#F0F0F0"
      />
      <path
        d="M3.2168 14.3561L4.0208 14.3841L4.29577 13.6284L4.51772 14.4017L5.32148 14.4297L4.65464 14.8796L4.87627 15.6527L4.24252 15.1575L3.57562 15.6072L3.85073 14.8514L3.2168 14.3561Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24218 -0.000366211 3.13143 2.76831 1.19043 6.78226H22.809Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3777">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VE;
